import { useLocation } from 'react-router-dom';

export default function AppHeader() {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return null;

  return (
    <header className="w-full flex flex-col items-center pt-3 sm:pt-5 pb-1 sm:pb-2 shrink-0" data-testid="app-header">
      <a href="https://juunit.com" target="_blank" rel="noopener noreferrer">
        <img
          src="/juunit-logo.png"
          alt="Juunit"
          className="max-w-[100px] sm:max-w-[140px] h-auto"
          data-testid="juunit-logo"
        />
      </a>
      <span className="mt-2 sm:mt-3 inline-block px-2 sm:px-3 py-0.5 sm:py-1 text-[10px] sm:text-xs font-mono text-[#3B82F6] border border-[#3B82F6]/30 rounded-full bg-[#3B82F6]/10 tracking-wider uppercase">
        IT-QUIZ
      </span>
    </header>
  );
}
